import { useState } from "react";
import { snakifyKeys } from "../../../util/helpers";
import { api, extractErrorMessage } from "../../../util/api";
import { Alert, Button, Modal, ModalBody, ModalHeader } from "reactstrap";
import { Form } from "react-final-form";
import { PayorNoteForm } from "./PayorNoteForm";

export const EditPayorNoteModal = ({ payorId, note, onUpdate, ...rest }) => {
  const [open, setOpen] = useState(false);
  const [error, setError] = useState(null);

  const toggleModal = () => setOpen(!open);

  const handleUpdate = async (values) => {
    setError(null);
    try {
      values.payor_id = payorId;
      const res = await api.patch(`/admin/payor_notes/${note.id}`, { payor_note: snakifyKeys(values) });

      if (onUpdate) {
        onUpdate(res.data.resource);
      }

      setOpen(false);
    } catch (err) {
      setError(extractErrorMessage(err));
    }
  };

  return (
    <>
      <Button onClick={toggleModal} {...rest}>
        Edit
      </Button>

      <Modal isOpen={open} toggle={toggleModal}>
        <ModalHeader toggle={toggleModal}>Edit Note</ModalHeader>

        <ModalBody>
          {error && <Alert color="danger">{error}</Alert>}

          <Form onSubmit={handleUpdate} initialValues={note}>
            {(props) => <PayorNoteForm {...props} />}
          </Form>
        </ModalBody>
      </Modal>
    </>
  );
};
